// extracted by css-extract-rspack-plugin
export default {"popover":"nZmSTphI4Z83KpgY","arrow":"kTqCbASFBoEe0z_v","slide":"LzeQWhAWSGMhyZX0","default":"xZ8Ere9sCw11qHHd","fit":"ecPohjKf0OOseIXJ","trigger":"bXGC9bLRwbRKU232"};